import type { MembersDict } from '../en/members';

export const members: MembersDict = {
  title: 'Medlemmar',
  subtitle: (org: string) => `Personer i ${org} som kan använda Queri.`,
  seats: (used: number, limit: number) => `${used} av ${limit} platser används`,
  seatsUnlimited: (used: number) => `${used} medlemmar och väntande inbjudningar`,
  inviteLabel: 'Bjud in via e-post',
  invitePlaceholder: 'namn@foretag.se',
  invite: 'Bjud in',
  inviting: 'Skickar…',
  invited: (email: string) => `Inbjudan skickad till ${email}`,
  inviteFailed: 'Det gick inte att skicka inbjudan',
  inviteHint: 'De får ett e-postmeddelande med en egen länk för att gå med.',
  people: 'Personer',
  name: 'Namn',
  role: 'Roll',
  status: 'Status',
  joined: 'Gick med',
  admin: 'Administratör',
  member: 'Medlem',
  you: 'du',
  active: 'Aktiv',
  invitedStatus: 'Har inte loggat in ännu',
  makeAdmin: 'Gör till administratör',
  makeMember: 'Gör till medlem',
  remove: 'Ta bort',
  removeTitle: 'Ta bort medlem',
  removeDescription: (name: string) =>
    `${name} kommer inte längre att kunna logga in. Deras projekt och playbooks flyttas till dig.`,
  cancel: 'Avbryt',
  removed: 'Medlemmen har tagits bort',
  roleChanged: 'Rollen har uppdaterats',
  actionFailed: 'Något gick fel',
  pending: 'Väntande inbjudningar',
  sent: 'Skickad',
  expires: 'Går ut',
  expired: 'Utgången',
  resend: 'Skicka igen',
  revoke: 'Återkalla',
  resent: 'Inbjudan skickad igen',
  revoked: 'Inbjudan återkallad',
  noAccess: 'Endast administratörer kan hantera medlemmar. Fråga en administratör i er organisation.',
};
